import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { environment } from "src/environments/environment";
import { ValidateTokenGuard } from "@app/guards/validate-token.guard";
import { SecurityService } from "@pages/authentication/services/security.service";
import { IGetTipoReferencia } from "@pages/fabrica-credito/abc-clientes-solicitudes/cliente/interfaces/IRefComercial";
import { OpcionesRequest } from "@shared/interfaces/request/opciones";
import { IGetDepto_Ciudad, IGetDepto_CiudadRes } from "@p-p-portafolio/promociones/interfaces/IGetDepto_Ciudad";

const httpOption = {
    headers: new HttpHeaders({
        "Content-Type": "application/json",
    }),
};

@Injectable({
    providedIn: "root",
})
export class OpcionesService {
    private baseUrl = environment.apiBaseUrl + "api/opciones";
    private token: string;

    constructor(private http: HttpClient, private securityService: SecurityService) {
        this.securityService.validateToken();
        this.token = sessionStorage.getItem("Token");
    }

    private getHeaders(): HttpHeaders {
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.token}`,
        });
        return headers;
    }

    form: UntypedFormGroup = new UntypedFormGroup({
        sEtiqueta: new UntypedFormControl(null, [Validators.required]),
        iValor: new UntypedFormControl("", [Validators.maxLength(40)]),
    });

    initializeFormGroup() {
        this.form.setValue({
            sOpcion: "",
            sValor: "",
        });
    }

    getAll(campo: string) {
        const url = `${this.baseUrl}/load/${campo}`;
        return this.http.get<Response>(url);
    }

    loadCombos(model: OpcionesRequest) {
        const url = environment.apiBaseUrl + "api/Opciones/load";
        const headers = this.getHeaders();
        return this.http.post<Response>(url, model, { headers });
    }

    GetTipoReferencia() {
        return this.http.post<IGetTipoReferencia>(environment.apiNewBackBaseUrl + "Opciones/GetTipoReferencia", {});
    }

    GetAllMoneda() {
        return this.http.get<any>(environment.apiNewBackBaseUrl + "Opciones/GetAllMoneda");
    }

    GetClientePropio() {
        return this.http.get<IGetTipoReferencia>(environment.apiNewBackBaseUrl + "Opciones/GetClientePropio");
    }

    GetVigencia() {
        return this.http.post<IGetTipoReferencia>(environment.apiNewBackBaseUrl + "Opciones/GetVigencia", {});
    }

    GetEstados() {
        return this.http.post<IGetTipoReferencia>(environment.apiNewBackBaseUrl + "Opciones/GetEstados", {});
    }

    GetDeptoCiu(payload: IGetDepto_Ciudad) {
        return this.http.post<IGetDepto_CiudadRes>(environment.apiNewBackBaseUrl + "DeptoCiudad/GetDepto_Ciudad", payload);
    }
}
